import { Component } from "react";
import { LabelContainer, LongLabelContainer, MapLabelContainer } from "../assets/style";
import { Box } from "@mui/material";

export default function MapLabel(props: { title: any, value: any }) {
    const { title, value } = props
    const inputStyle = {
        margin: "2px",
        width: "100%",

    };

    const containerStyle = {
        display: "flex",
        alignItems: "center",
    };

    return (
        <div style={containerStyle}>
            <MapLabelContainer >
                {title + ": "}
            </MapLabelContainer>
            <MapLabelContainer style={inputStyle}>
                {value}
            </MapLabelContainer>
        </div>
    );
}
